<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser1" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="联系名称">
                  <el-input style="width: 177px;" v-model="queryForm.contactName"></el-input>
              </el-form-item>
              <el-form-item label="联系类型">
<!--                  <el-input style="width: 177px;" v-model="queryForm.contactType"></el-input>-->
                  <el-select
                      size="small"
                      v-model="queryForm.contactType"
                      placeholder="请选择"
                      clearable
                      style="width: 177px"
                  >
                      <el-option v-for='(item, index) in urgentStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getImWebimFloatList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addImWebimFloat"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editImWebimFloat(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteImWebimFloat(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshImWebimFloatList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="imWebimFloatList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contactName"
        label="联系名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contactContent"
        label="联系内容"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="contactType"
        label="联系类型"
        width="180"
      > 
        <template slot-scope="scope">
          {{ getadslinks(scope.row.contactType) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkImWebimFloat(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editImWebimFloat(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteImWebimFloat(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="imWebimFloatStates[imWebimFloatState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="imWebimFloat"
          ref="imWebimFloatForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <!-- <el-form-item
            label="ID"
            prop="id"
          >
            <el-input
              size="small"
              v-model="imWebimFloat.id"
              :disabled="imWebimFloatState == 'check'"
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="用户"
            prop="userId"
            v-if="isSa == 1"
          >
            <!-- <el-input
              size="small"
              v-model="imWebimFloat.userId"
              :disabled="imWebimFloatState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 177px;" labelName="userName" :disabled="imWebimFloatState == 'check'"
                labelValue="id" title="选择用户" :value="imWebimFloat.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser1" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="联系名称"
            prop="contactName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimFloat.contactName"
              :disabled="imWebimFloatState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系内容"
            prop="contactContent"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimFloat.contactContent"
              :disabled="imWebimFloatState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系类型"
            prop="contactType"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimFloat.contactType"
              :disabled="imWebimFloatState == 'check'"
            ></el-input> -->
            <el-select
                size="small"
                v-model="imWebimFloat.contactType"
                placeholder="请选择"
                :disabled="imWebimFloatState == 'check'"
                style="width: 177px"
            >
              <el-option v-for='(item, index) in urgentStatusEnum' :key='index' :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimFloat.sort"
              :disabled="imWebimFloatState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="imWebimFloatState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { CUSTOMER, CUSTOMER_SEARCH, USER, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetImWebimFloatList();
                    this.getImWebimFloatList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetImWebimFloatList();
                    this.getImWebimFloatList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     contactName: '', //联系名称
                     contactContent: '', //联系内容
                     contactType: '', //联系类型：1客服 2QQ 3二维码 4电话 5网址 
                     sort: '', //排序
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                imWebimFloatState: 'add',
                imWebimFloatStates: {
                    add: '新建浮窗',
                    check: '查看浮窗',
                    edit: '修改浮窗'
                },

                multipleSelection: [],
                imWebimFloatList: [],
                imWebimFloat: {
                    // id: '', //ID
                    userId: '', //用户
                    contactName: '', //联系名称
                    contactContent: '', //联系内容
                    contactType: '', //联系类型：1客服 2QQ 3二维码 4电话 5网址 
                    sort: '', //排序
                    createTime: '', //
                },
                btnLoading: false,
                isSa:'',
                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    contactName: [{ required: true, message: '联系名称不能为空', trigger: 'blur' }],
                    contactContent: [{ required: true, message: '联系内容不能为空', trigger: 'blur' }],
                    contactType: [{ required: true, message: '联系类型不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },
                urgentStatusEnum:[],
            };
        },
        created() {
            this.getImWebimFloatList();
            this.getIsSa();
            this.geturgentStatusEnum();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getValueUser1(value){
              this.imWebimFloat.userId = value;
            },
            getSearchValueUser1(value){
                this.queryForm.userId = value;
            },
            getadslinks(key){
                for (const iterator of this.urgentStatusEnum) {
                    if(iterator.key == key){
                        return iterator.value
                    }
                }
            },
            geturgentStatusEnum(){
              get('/im/utils/getEnum', {enumType:'contact_type'}).then((res)=>{
                  this.urgentStatusEnum = res.enumList;
              });
            },
            getIsSa(){
              get('/mpp/user/getIsSa').then(res=>{
                if(res.success){
                  this.isSa=res.isSa;
                }
              })
            },
            resetImWebimFloatList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.imWebimFloatList = [];
            },
            resetDialog() {
                this.imWebimFloatState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      contactName: '', //联系名称
                      contactContent: '', //联系内容
                      contactType: '', //联系类型：1客服 2QQ 3二维码 4电话 5网址 
                      sort: '', //排序
                };
                this.getImWebimFloatList();
            },
            closeDialog() {
                this.showDialog = false
                this.imWebimFloat = {
                      // id: '', //ID
                      userId: '', //用户
                      contactName: '', //联系名称
                      contactContent: '', //联系内容
                      contactType: '', //联系类型：1客服 2QQ 3二维码 4电话 5网址 
                      sort: '', //排序
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.imWebimFloatState == 'add') {
                    this.$refs.imWebimFloatForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimfloat/add`,{ ...this.imWebimFloat }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetImWebimFloatList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.imWebimFloatState == 'edit') {
                    this.$refs.imWebimFloatForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimfloat/edit`,{ ...this.imWebimFloat }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetImWebimFloatList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addImWebimFloat() {
                this.showDialog = true;
                this.imWebimFloatState = 'add';
            },
            checkImWebimFloat(imWebimFloatId) {
                console.log(imWebimFloatId);
                this.currentImWebimFloatId = imWebimFloatId;

                this.getImWebimFloatById();
                this.showDialog = true;
                this.imWebimFloatState = 'check';
            },
            editImWebimFloat(imWebimFloatId) {
                console.log('imWebimFloat', imWebimFloatId);
                if (imWebimFloatId) {
                    this.currentImWebimFloatId = imWebimFloatId;
                    this.getImWebimFloatById();
                } else {
                    this.imWebimFloat = { ...this.imWebimFloat, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.imWebimFloatState = 'edit';
            },
            deleteImWebimFloat(imWebimFloatId) {
                let ids = '';
                if (imWebimFloatId) {
                    ids = imWebimFloatId;
                } else {
                    ids = this.multipleSelection.map((imWebimFloat) => imWebimFloat.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/im/webimfloat/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetImWebimFloatList();
                                this.getImWebimFloatList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshImWebimFloatList() {
                this.resetImWebimFloatList();
                this.getImWebimFloatList();
            },
            getImWebimFloatList(query = {}) {
                this.loading = true;
                get(`/im/webimfloat/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.imWebimFloatList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getImWebimFloatById() {
                get(`/im/webimfloat/get`,{ id: this.currentImWebimFloatId }).then((res) =>{
                    if(res.success){
                      this.imWebimFloat = { ...this.imWebimFloat, ...res.imWebimFloat };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportImWebimFloatList() {
                //this.btnLoading = true;
                exprotExcel(`/im/webimfloat/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/im/webimfloat/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/im/webimfloat/importData`,formData);
              this.refreshImWebimFloatList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getImWebimFloatList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getImWebimFloatList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>